import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import PaymentDetail from './PaymentDetail';
import OrderPaymentScheduleDetail from './OrderPaymentScheduleDetail';

const OrderPaymentDetail = ({ modelName, pendingStepFocus, isLast, includeTotal = true }) => (
	<>
		{includeTotal ? (
			<Row>
				<PaymentDetail />
			</Row>
		) : null}
		<OrderPaymentScheduleDetail modelName={modelName} pendingStepFocus={pendingStepFocus} isLast={isLast} />
	</>
);

OrderPaymentDetail.propTypes = {
	modelName: PropTypes.string,
	pendingStepFocus: PropTypes.oneOf(['prePayment']),
	isLast: PropTypes.bool,
	includeTotal: PropTypes.bool,
};

export default OrderPaymentDetail;
